<template>
  <div>
    <!-- 招商竞价详情 -->
    <div v-if="entity.orderType == '30'" class="index" style="background: white;">
      <el-row class="basic-info">
        <el-row style="margin-left: 40px; min-width: 1200px; max-width: 1200px;">
          <el-row style="margin-top: 16px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{name: 'index'}">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{name: 'auction'}">采购结果</el-breadcrumb-item>
              <el-breadcrumb-item>结果详情</el-breadcrumb-item>
            </el-breadcrumb>
          </el-row>

          <el-row type="flex" justify="center" style="padding: 16px 0px;"><label style="font-size: 20px;color: #333333;font-weight: bold">{{entity.collegeName}} - {{entity.currentProcee == 'PUBLICITY'?'结果公示':'结果公告'}} ({{entity.orderCode}})</label></el-row>

          <el-row style="margin: 8px 0;text-align: center">
            <el-col style="color: #999;font-size: 12px;">
              <span>发布单位：{{entity.collegeName}}</span>
              <span style="margin: 0px 48px">发布时间：{{entity.publicityTime?entity.publicityTime:entity.publishBidresultTime, 'yyyy-MM-dd' | fmtDate}}</span>
              <!--            <span>阅读量：{{entity.readCount || 0}}次</span>-->
            </el-col>
          </el-row>

          <div class="auction-details">
            <el-row>
              <el-col>
                <div class="title-text"><span>基本信息:</span></div>
                <div class="small-line"></div>
                <div class="title-line"></div>
              </el-col>
            </el-row>

            <div style="padding: 16px 0px;">
              <el-row>
                <el-col :span="10" :offset="2">
                  <el-form label-width="120px" label-suffix="："  inline style="font-size: 14px;color: #333333;">
                    <el-form-item label="申购单号">{{entity.orderCode}}</el-form-item>

                    <el-form-item label="采购单位">
                      <label v-if="getByteLen(entity.collegeName) <= 64">{{entity.collegeName}}</label>
                      <el-tooltip v-else effect="light" :content="entity.collegeName" placement="bottom">
                        <label>{{entity.collegeName | cutStr(64)}}</label>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item label="竞价开始时间" v-if="entity.startBidtime">{{entity.startBidtime, 'yyyy-MM-dd' | fmtDate}}</el-form-item>
                    <el-form-item label="竞价截至时间" v-if="entity.endBidtime">{{entity.endBidtime, 'yyyy-MM-dd' | fmtDate}}</el-form-item>
                    <!--<el-form-item label="预算">-->
                    <!--<label v-if="entity.budgetIsOpen === 'N'">******</label>-->
                    <!--<label v-else style="text-decoration-line: underline;"><span v-show="entity.budget > 0">{{entity.correncySymbol}}{{entity.budget | moneyFormat}}</span></label>-->
                    <!--</el-form-item>-->
                  </el-form>
                </el-col>
                <el-col :span="11" :offset="1">
                  <el-form label-width="120px" label-suffix="："  inline style="font-size: 14px;color: #333333;">
                    <el-form-item label="申购主题">
                      <label v-if="getByteLen(entity.orderTitle) <= 64">{{entity.orderTitle}}</label>
                      <el-tooltip v-else effect="light" :content="entity.orderTitle" placement="bottom">
                        <label>{{entity.orderTitle | cutStr(64)}}</label>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item label="币种">{{entity.usingCorrency}}</el-form-item>
                    <el-form-item label="安装要求">{{entity.installations}}</el-form-item>
                  </el-form>
                </el-col>
              </el-row>

              <el-row>
                <el-col :offset="2">
                  <el-form label-width="120px" label-suffix="："  inline style="font-size: 14px;color: #333333;width: 85%">
                    <!--<el-form-item label="备注说明">-->
                    <!--<el-input v-model="entity.remark" type="textarea" autosize readonly></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="备注说明" class="puInp" style="width: 100%" >
                      <el-input v-model="entity.remark" type="textarea" autosize readonly style="width: 657%" ></el-input>
                    </el-form-item>
                    <el-form-item :label="isJSON(entity.otherExplain)[0]" class="puInp" style="width: 100%" v-if="isJSON(entity.otherExplain)">
                      <el-input v-model="isJSON(entity.otherExplain)[1]" type="textarea" autosize readonly style="width: 657%;" ></el-input>
                    </el-form-item>

                  </el-form>
                </el-col>
              </el-row>
            </div>

            <el-row style="padding-top: 16px;">
              <el-col>
                <div class="title-text"><span>采购结果:</span></div>
                <div class="small-line"></div>
                <div class="title-line"></div>
              </el-col>
            </el-row>

<!--            <el-table-->
<!--              :header-cell-style="headerClass"-->
<!--              :data="zsDataList?zsDataList:detailList"-->
<!--              border-->
<!--              style="width: 100%;margin-top: 20px">-->
<!--              <el-table-column-->
<!--                prop="index"-->
<!--                label="序号"-->
<!--                width="50">-->
<!--                <template slot-scope="scope">{{scope.$index + 1}}</template>-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="deviceName"-->
<!--                label="采购项"-->
<!--              >-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                v-if="!isGWZF"-->
<!--                prop="deviceBrand"-->
<!--                label="品牌">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                v-if="!isGWZF"-->
<!--                prop="deviceModel"-->
<!--                label="型号">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                v-if="!isZF"-->
<!--                prop="afterService"-->
<!--                label="质保及售后服务">-->
<!--                &lt;!&ndash;              <template slot-scope="scope">&ndash;&gt;-->
<!--                &lt;!&ndash;                <div class="custom_scrollbar" style="max-height: 170px;">&ndash;&gt;-->
<!--                &lt;!&ndash;                  {{scope.row.afterService}}&ndash;&gt;-->
<!--                &lt;!&ndash;                </div>&ndash;&gt;-->
<!--                &lt;!&ndash;              </template>&ndash;&gt;-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="bidPrice"-->
<!--                label="折扣率">-->
<!--                <template slot-scope="scope">-->
<!--                  <div class="custom_scrollbar" style="max-height: 170px;">-->
<!--                    {{scope.row.bidPrice}}-->
<!--                  </div>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="companyName"-->
<!--                label="中标供应商">-->
<!--              </el-table-column>-->
<!--            </el-table>-->


            <!--          招商竞价专用表格-->


            <el-table
              v-if="entity.orderType == '30'"
              :header-cell-style="headerClass"
              :data="zsDataList?zsDataList:detailList"
              border
              :span-method="objectSpanMethod"
              style="width: 100%;margin-top: 20px">
                          <el-table-column
                            prop="type"
                            label="序号"
                            width="50">
                            <template slot-scope="scope">{{scope.row.type}}</template>
                          </el-table-column>
<!--              <el-table-column-->
<!--                width="50"-->
<!--                prop="type"-->
<!--                label="序号"-->
<!--              >-->
<!--              </el-table-column>-->
              <el-table-column
                prop="deviceName"
                label="采购项"
              >
              </el-table-column>
              <el-table-column
                v-if="!isGWZF"
                prop="deviceBrand"
                label="品牌">
              </el-table-column>
              <el-table-column
                v-if="!isGWZF"
                prop="deviceModel"
                label="型号">
              </el-table-column>
              <el-table-column
                v-if="!isZF"
                prop="afterService"
                label="质保及售后服务">
                <!--              <template slot-scope="scope">-->
                <!--                <div class="custom_scrollbar" style="max-height: 170px;">-->
                <!--                  {{scope.row.afterService}}-->
                <!--                </div>-->
                <!--              </template>-->
              </el-table-column>
              <el-table-column
                prop="bidPrice"
                label="折扣率 / 成交总价">
                <template slot-scope="scope">
                  <div class="custom_scrollbar" style="max-height: 170px;">
                    {{scope.row.bidPrice}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                label="中标供应商">
                <template slot-scope="scope">
                    {{scope.row.companyName}}
                </template>
              </el-table-column>
            </el-table>
          </div>

          <el-row style="padding-bottom: 40px;"></el-row>
          <div class="title-info" style="margin: 20px 0">
            <span style="color: red;font-size: 16px;">严正声明：未经本平台授权，严禁以任何形式转载或使用本平台数据，一经发现，依法追究法律责任。</span>
          </div>
        </el-row>

        <a :href="CONFIG.qqHref" target="_blank" :title="CONFIG.qqTip"><div class="service-box"><img class="qq" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFjUlEQVR4XuWbaYxeUxjHf3/7rpakljQi/SCliKattFW1iyXWWGJNLSEIJdFYGsTSEKIUsSZKCPUFsUTsS21RVDSUkFiCENS+6yP/ujOm03fmnnPfO2/v1PNlJjnPeZb/e+69z3bE/5zUSf8jYmVgS2BrYBSwLbAi8DPwOvAT8BYwX9JnnbBtwAGICDt4CHAksAewSqJjXwCzgRskfZC4J5ttwACIiHWA44EzgM2yLftvQwAPAGdK+rgNOS23DggAEbEzcB+wYY0G/w5cC1wo6be65NYOQERMAy4GapddOP0JsKekBXWAUKuREXG1j2odhpXI+A7YXdLcdnXVAkBEWM7NwIntGpSxfyEwtt0XZF0A+NhfkmF8Xawf+lMqyZ/RStQ2ABGxOfAusGolC9rfNEvS5Kpi6gDgYWCfqgbUtM/vgyeryGoLgIgYDbxWRXHNe+ZKGlNFZrsAPAtMqqJ4APbsKOmFXLmVAYiIYYC/yU2huyUdlWtMOwCcD1yaq3AA+X8Fhkj6I0dHOwD42fc7oEl0kKT7cwyqBECR1joeXyFHWQd4Z0g6K0dPVQCa8vbv7euLknboBAAnALfmKOoQ75/A6pL+TtVX9QRc5LQ0VUmH+YZK+ipVZ1UArgdOTVXSYb6tJL2TqrMqAPcCh6Uq6TDfJEnPp+rMBiAi1gdeArZIVdJhvmmSLkvVmQVAUeB09dbV3KbSImBXSQ7TSykXAB97H/+m0wJJI1KMzAVgFnBsiuAG8LhaVJqp5gLgt2sSsg0A4HRJ15XZkQuA63BDyoQ2ZH26JCds/VIuAM603N4aDDRTkpsytQLwA7B2mdCGrF8h6ZwyW5JPQFH6/hzYqExoQ9bdQXKDpp4TEBHTgXPLBDZo3ad1XFlYnHQCIsJxv+P/wUY+seP7a6qWAhAREwDH1k0rfqT+GJ43GCPJqfJS1C8ARYvbTciNU7U1lO9KSVOrAHAHcExDncoxyzMG27eKDPs8ARGxHfBGjpaG886TZJ+WoP4AeATYu+FO5Zq3ryT71U0tAYiIkcDbudIHAf8cSRNTALimmO0ZBD5lmzii53TJUicgIlYCvgbWzRY9ODYsESK3AmBcUfIaHO7kW7nEy7AVAA53HfYur+RP4jqSPJS59CRXRHgmb//l1fvCr70kPdYXAE8Auy3nAHQ3UVs9Ag8C+7UA4LxB9mi8AvzocboWvnTHA60AcM/Pvb+edI+kIyLi8T4ENvHAHAy8CjiXWauXgU6OFs8YtgKgd+r7aTGKtjAiDgCy+u/LCBmnwcMkLYoID2p7bLcneZDi+74A2ASw005/PZE5UdJ8MxdVIf/vkfcm0xRJniteTBHhSZauAunLksZ3rfUVCrv2vxNwgSSD0U3FIPTTDfb+PWCkpL962X04cCBwuaQ3+wWgzLmI8Bz/oWV8y2jdJ3ZOqu7SilArQRHhAsn7LV4uqXoHim+2JP/SyVQJgOK5Ogm4KVnTwDO6aTNckv8mUyUAImLNYjh6ygDeC0h2omD8qLhV4kg2mbIBiAhHiXcBQ5O1dJbxIWCypG9S1GYBEBGeC3CEtVqK8GXI4zH60ZL8Ge+XkgGICDvtGGB4mdCGrN8mqfQCRw4AJwM3NsS5FDN8yWqDsssUOQDc0uErMSlOlvGM6hn0tGLOAeBO4OgyjQ1bnyDJA119Ug4Afp58Cuokx+hPFXnHDGCbGoW7ObppV+WnL7k5APgKrNEcW4ORfj6nSprZJatow7kW4RykDjpO0u1lgpIBsKCI8HiMs6pTgDXKhLdYd7XZg1ZXSfqy1f4i2Tq7uGds0HPpF9snyW29UsoCoMev5Suxp/kGpzuvxQ3wVsqckc0DPLP3KPCcc/RSq/4Fez3ARY1dAF/F7W8w41vgGcAFG+cDi3P9FPoHZtGfUJ0VObsAAAAASUVORK5CYII="><span>在线客服</span></div></a>
      </el-row>

      <!--    <Footer></Footer>-->

      <Slide></Slide>
    </div>
    <!-- 非招商竞价详情 -->
    <div v-else class="index" style="background: white;">
      <el-row class="basic-info">
        <el-row style="margin-left: 40px; min-width: 1200px; max-width: 1200px;">
          <el-row style="margin-top: 16px;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{name: 'index'}">首页</el-breadcrumb-item>
              <el-breadcrumb-item :to="{name: 'auction'}">采购结果</el-breadcrumb-item>
              <el-breadcrumb-item>结果详情</el-breadcrumb-item>
            </el-breadcrumb>
          </el-row>

          <el-row type="flex" justify="center" style="padding: 16px 0px;"><label style="font-size: 20px;color: #333333;font-weight: bold">{{entity.collegeName}} - {{entity.currentProcee == 'PUBLICITY'?'结果公示':'结果公告'}} ({{entity.orderCode}})</label></el-row>

          <el-row style="margin: 8px 0;text-align: center">
            <el-col style="color: #999;font-size: 12px;">
              <span>发布单位：{{entity.collegeName}}</span>
              <span style="margin: 0px 48px">发布时间：{{entity.publicityTime?entity.publicityTime:entity.publishBidresultTime, 'yyyy-MM-dd' | fmtDate}}</span>
              <!--            <span>阅读量：{{entity.readCount || 0}}次</span>-->
            </el-col>
          </el-row>

          <div class="auction-details">
            <el-row>
              <el-col>
                <div class="title-text"><span>基本信息:</span></div>
                <div class="small-line"></div>
                <div class="title-line"></div>
              </el-col>
            </el-row>

            <div style="padding: 16px 0px;">
              <el-row>
                <el-col :span="10" :offset="2">
                  <el-form label-width="120px" label-suffix="："  inline style="font-size: 14px;color: #333333;">
                    <el-form-item label="申购单号">{{entity.orderCode}}</el-form-item>
                    <el-form-item :label="entity.orderType === '12' ? '项目主题' : '申购主题'" class="custom-form-item">
                      <label v-if="getByteLen(entity.orderTitle) <= 64">{{entity.orderTitle}}</label>
                      <el-tooltip v-else effect="light" :content="entity.orderTitle" placement="bottom">
                        <label>{{entity.orderTitle | cutStr(64)}}</label>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item label="采购单位">
                      <label v-if="getByteLen(entity.collegeName) <= 64">{{entity.collegeName}}</label>
                      <el-tooltip v-else effect="light" :content="entity.collegeName" placement="bottom">
                        <label>{{entity.collegeName | cutStr(64)}}</label>
                      </el-tooltip>
                    </el-form-item>
                    <el-form-item label="竞价开始时间" v-if="entity.startBidtime">{{entity.startBidtime, 'yyyy-MM-dd' | fmtDate}}</el-form-item>
                    <el-form-item label="竞价截至时间" v-if="entity.endBidtime">{{entity.endBidtime, 'yyyy-MM-dd' | fmtDate}}</el-form-item>
                    <el-form-item label="币种">{{entity.usingCorrency}}</el-form-item>
                    <!--<el-form-item label="预算">-->
                    <!--<label v-if="entity.budgetIsOpen === 'N'">******</label>-->
                    <!--<label v-else style="text-decoration-line: underline;"><span v-show="entity.budget > 0">{{entity.correncySymbol}}{{entity.budget | moneyFormat}}</span></label>-->
                    <!--</el-form-item>-->
                  </el-form>
                </el-col>
                <el-col :span="11" :offset="1">
                  <el-form label-width="120px" label-suffix="："  inline style="font-size: 14px;color: #333333;">
                    <el-form-item label="成交总额">
                      <label style="text-decoration-line: underline;color: #ea1111;">{{entity.correncySymbol}}{{entity.bidAmount}}</label> ({{entity.usingCorrency}})
                    </el-form-item>
                    <!--<el-form-item label="签约时间">{{entity.contractLimit}}</el-form-item>-->
                    <el-form-item :label="entity.orderType === '12' ? '完成时间' : '送货时间'">{{entity.deliverTime}}</el-form-item>
                    <el-form-item v-if="entity.orderType !== '12'" label="安装要求">{{entity.installations}}</el-form-item>
                    <el-form-item :label="entity.orderType === '12' ? '出租地址' : '收货地址'">
                      <label v-if="getByteLen(entity.deliverPlace) <= 64">{{entity.deliverPlace}}</label>
                      <el-tooltip v-else effect="light" :content="entity.deliverPlace" placement="bottom">
                        <label>{{entity.deliverPlace | cutStr(64)}}</label>
                      </el-tooltip>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>

              <el-row>
                <el-col :offset="2">
                  <el-form label-width="120px" label-suffix="："  inline style="font-size: 14px;color: #333333;width: 85%">
                    <el-form-item :label="entity.orderType === '12' ? '结算方式' : '付款方式'">{{entity.payType}}</el-form-item>
                    <!--<el-form-item label="备注说明">-->
                    <!--<el-input v-model="entity.remark" type="textarea" autosize readonly></el-input>-->
                    <!--</el-form-item>-->
                    <el-form-item label="备注说明" class="puInp" style="width: 100%" >
                      <el-input v-model="entity.remark" type="textarea" autosize readonly style="width: 657%" ></el-input>
                    </el-form-item>
                    <!--<el-form-item label="质疑说明" >-->
                    <!--{{entity.doubtDesc}}-->
                    <!--</el-form-item>-->
                    <el-form-item label="质疑说明" class="puInp ColRed" style="width: 100%" v-if="!isJSON(entity.otherExplain)">
                      <el-input v-model="entity.doubtDesc" type="textarea" autosize readonly style="width: 657%;" ></el-input>
                    </el-form-item>
                    <el-form-item :label="isJSON(entity.otherExplain)[0]" class="puInp" style="width: 100%" v-if="isJSON(entity.otherExplain)">
                      <el-input v-model="isJSON(entity.otherExplain)[1]" type="textarea" autosize readonly style="width: 657%;" ></el-input>
                    </el-form-item>

                  </el-form>
                </el-col>
              </el-row>
            </div>

            <el-row style="padding-top: 16px;">
              <el-col>
                <div class="title-text"><span>采购结果:</span></div>
                <div class="small-line"></div>
                <div class="title-line"></div>
              </el-col>
            </el-row>

            <el-table
              :header-cell-style="headerClass"
              :data="detailList"
              border
              style="width: 100%;margin-top: 20px">
              <el-table-column
                prop="index"
                label="序号"
                width="50">
                <template slot-scope="scope">{{scope.$index+1}}</template>
              </el-table-column>
              <el-table-column
                :label="ProName(entity.orderType)"
                prop="deviceName"
                label="采购项"
              >
              </el-table-column>
              <el-table-column
                v-if="!isGWZF"
                prop="deviceBrand"
                label="品牌/型号/厂家/产地">
                <template slot-scope="scope">
                  <div>品牌：{{scope.row.deviceBrand}}</div>
                  <div>型号：{{scope.row.deviceModel}}</div>
                  <div>厂家：{{scope.row.manufacturer}}</div>
                  <div>产地：{{scope.row.producingArea}}</div>
                </template>
              </el-table-column>
              <el-table-column
                :label="labelName2(entity.orderType)"
              >
                <template slot-scope="scope">
                  <div class="custom_scrollbar" style="max-height: 170px;" v-if="entity.orderType === '3'">
                    <div class="custom_scrollbar" style="max-height: 170px;" :title="standardFormate(scope.row.deviceSpec)" v-html="standardFormate(scope.row.deviceSpec)"/>
                  </div>
                  <div class="custom_scrollbar" style="max-height: 170px;" v-else>
                    {{scope.row.deviceSpec}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="!isZF"
                prop="afterService"
                label="质保及售后服务">
                <template slot-scope="scope">
                  <div class="custom_scrollbar" :title="scope.row.afterService" style="max-height: 170px;">
                    {{scope.row.afterService}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="afterService"
                label="数量单位/单价">
                <template slot-scope="scope">
                  <div>
                    数量：{{scope.row.orderNum}}
                    <span v-if="scope.row.unit">({{scope.row.unit}})</span>
                  </div>
                  <div>
                    单价：{{scope.row.bidPrice}}({{entity.usingCorrency }})
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="afterService"
                label="成交总价">
                <template slot-scope="scope">
                  <div>
                    {{entity.correncySymbol}}{{scope.row.bidAmount}}({{entity.usingCorrency}})
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="companyName"
                label="成交供应商">
              </el-table-column>
            </el-table>
            <!--          <div v-for="(item,index) in detailList" :key="index">-->
            <!--            <el-row style="margin-top: 16px;background-color: #ededed;">-->
            <!--              <el-col :span="10" :offset="2">-->
            <!--                <el-form label-width="150px" label-suffix="：" inline style="font-size: 14px;color: #333333;">-->
            <!--                  <el-form-item label="采购项">-->
            <!--                    <label v-if="getByteLen(item.deviceName) <= 50">{{item.deviceName}}</label>-->
            <!--                    <el-tooltip v-else effect="light" :content="item.deviceName" placement="bottom">-->
            <!--                      <label>{{item.deviceName | cutStr(50)}}</label>-->
            <!--                    </el-tooltip>-->
            <!--                  </el-form-item>-->
            <!--                  &lt;!&ndash;<el-form-item label="型号">{{item.deviceModel}}</el-form-item>&ndash;&gt;-->


            <!--                  &lt;!&ndash;<el-form-item label="数量">{{item.orderNum}}{{item.unit}}</el-form-item>&ndash;&gt;-->
            <!--                  &lt;!&ndash;<el-form-item label="成交单价">{{entity.correncySymbol}}{{item.bidPrice | moneyFormat}}</el-form-item>&ndash;&gt;-->
            <!--                  <el-form-item label="品牌">{{item.deviceBrand}}</el-form-item>-->
            <!--                  <el-form-item label="型号">{{item.deviceModel}}</el-form-item>-->

            <!--                  <el-form-item label="质保及售后服务" style="display: flex;flex-direction: row">-->
            <!--                    <el-input v-model="item.afterService" type="textarea" class="textareaBc" autosize readonly></el-input>-->
            <!--                  </el-form-item>-->
            <!--&lt;!&ndash;                  <el-form-item label="技术参数">&ndash;&gt;-->
            <!--&lt;!&ndash;                    <div style="margin: 10px 0px;width: 350px;" v-show="!isShow" v-for="spec in jsonParse(item.deviceSpec)">&ndash;&gt;-->
            <!--&lt;!&ndash;                      <p style="line-height: 14px"><span v-show="spec.important" style="color: red">* </span>{{spec.value}}</p>&ndash;&gt;-->
            <!--&lt;!&ndash;                    </div>&ndash;&gt;-->
            <!--&lt;!&ndash;                    <el-input v-show="isShow" v-model="item.deviceSpec" type="textarea" class="textareaBc" autosize readonly></el-input>&ndash;&gt;-->

            <!--&lt;!&ndash;                  </el-form-item>&ndash;&gt;-->
            <!--                </el-form>-->
            <!--              </el-col>-->
            <!--              <el-col :span="1" style="height: 150px"><span style="position: relative;top: 50%;font-size: 70px;color: #cdcdcd">{{++index}}</span></el-col>-->
            <!--              <el-col :span="11">-->
            <!--                <el-form label-width="130px" label-suffix="：" inline style="font-size: 14px;color: #333333;">-->
            <!--                  &lt;!&ndash;<el-form-item label="品牌">{{item.deviceBrand}}</el-form-item>&ndash;&gt;-->
            <!--                  &lt;!&ndash;<el-form-item label="单项预算">&ndash;&gt;-->
            <!--                  &lt;!&ndash;<span v-if="item.detailBudget">{{entity.correncySymbol}}{{item.detailBudget | moneyFormat}}</span>&ndash;&gt;-->
            <!--                  &lt;!&ndash;</el-form-item>&ndash;&gt;-->
            <!--                  <el-form-item label="成交总价"><label style="color: #ea1111;text-decoration-line: underline;">{{entity.correncySymbol}}{{item.bidAmount | moneyFormat}}</label></el-form-item>-->
            <!--                  <el-form-item label="成交供应商">{{item.companyName}}</el-form-item>-->


            <!--                </el-form>-->
            <!--              </el-col>-->
            <!--            </el-row>-->
            <!--            <el-row v-if="!isNullOrUndefined(item.cpBidOrders)" style="background-color: #ededed;padding: 20px 55px;">-->
            <!--              <el-col :span="4">-->
            <!--                <div style="font-weight: 600;color: #666666;font-size: 14px;text-align: right;">供应商报价信息：</div>-->
            <!--              </el-col>-->
            <!--              <el-col :span="20">-->
            <!--                <el-table-->
            <!--                  :data="item.cpBidOrders"-->
            <!--                  border-->
            <!--                  style="width: 100%;"-->
            <!--                  :header-cell-style="getRowClass"-->
            <!--                  :row-class-name="tableRowClassName"-->
            <!--                >-->
            <!--                  <el-table-column-->
            <!--                    type="index"-->
            <!--                    label="序号"-->
            <!--                    width="80"-->
            <!--                  >-->
            <!--                  </el-table-column>-->
            <!--                  <el-table-column-->
            <!--                    prop="companyName"-->
            <!--                    label="供应商"-->
            <!--                  >-->
            <!--                  </el-table-column>-->
            <!--                  &lt;!&ndash;<el-table-column&ndash;&gt;-->
            <!--                  &lt;!&ndash;prop="deviceBrand"&ndash;&gt;-->
            <!--                  &lt;!&ndash;label="品牌"&ndash;&gt;-->
            <!--                  &lt;!&ndash;&gt;&ndash;&gt;-->
            <!--                  &lt;!&ndash;</el-table-column>&ndash;&gt;-->
            <!--                  &lt;!&ndash;<el-table-column&ndash;&gt;-->
            <!--                  &lt;!&ndash;prop="deviceModel"&ndash;&gt;-->
            <!--                  &lt;!&ndash;label="型号"&ndash;&gt;-->
            <!--                  &lt;!&ndash;&gt;&ndash;&gt;-->
            <!--                  &lt;!&ndash;</el-table-column>&ndash;&gt;-->
            <!--                  &lt;!&ndash;<el-table-column&ndash;&gt;-->
            <!--                  &lt;!&ndash;prop="totalAmount"&ndash;&gt;-->
            <!--                  &lt;!&ndash;label="技术参数"&ndash;&gt;-->
            <!--                  &lt;!&ndash;&gt;&ndash;&gt;-->
            <!--                  &lt;!&ndash;<template slot-scope="scope">&ndash;&gt;-->
            <!--                  &lt;!&ndash;<div style="margin: 10px 0px;width: 350px;" v-show="!isShow" v-for="spec in jsonParse(scope.row.deviceSpec)">&ndash;&gt;-->
            <!--                  &lt;!&ndash;<p style="line-height: 14px"><span v-show="spec.important" style="color: red">* </span>{{spec.value}}</p>&ndash;&gt;-->
            <!--                  &lt;!&ndash;</div>&ndash;&gt;-->
            <!--                  &lt;!&ndash;<el-input v-show="isShow" v-model="scope.row.deviceSpec" type="textarea" class="textareaBc2" autosize readonly ></el-input>&ndash;&gt;-->
            <!--                  &lt;!&ndash;</template>&ndash;&gt;-->
            <!--                  &lt;!&ndash;</el-table-column>&ndash;&gt;-->
            <!--                  <el-table-column-->
            <!--                    prop="totalAmount"-->
            <!--                    label="总价"-->
            <!--                  >-->
            <!--                  </el-table-column>-->
            <!--                  &lt;!&ndash;<el-table-column&ndash;&gt;-->
            <!--                  &lt;!&ndash;prop="afterService"&ndash;&gt;-->
            <!--                  &lt;!&ndash;label="售后服务"&ndash;&gt;-->
            <!--                  &lt;!&ndash;&gt;&ndash;&gt;-->
            <!--                  &lt;!&ndash;</el-table-column>&ndash;&gt;-->
            <!--                </el-table>-->
            <!--              </el-col>-->
            <!--            </el-row>-->
            <!--          </div>-->
          </div>

          <el-row style="padding-bottom: 40px;"></el-row>
          <div class="title-info" style="margin: 20px 0">
            <span style="color: red;font-size: 16px;">严正声明：未经本平台授权，严禁以任何形式转载或使用本平台数据，一经发现，依法追究法律责任。</span>
          </div>
        </el-row>

        <a :href="CONFIG.qqHref" target="_blank" :title="CONFIG.qqTip"><div class="service-box"><img class="qq" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAFjUlEQVR4XuWbaYxeUxjHf3/7rpakljQi/SCliKattFW1iyXWWGJNLSEIJdFYGsTSEKIUsSZKCPUFsUTsS21RVDSUkFiCENS+6yP/ujOm03fmnnPfO2/v1PNlJjnPeZb/e+69z3bE/5zUSf8jYmVgS2BrYBSwLbAi8DPwOvAT8BYwX9JnnbBtwAGICDt4CHAksAewSqJjXwCzgRskfZC4J5ttwACIiHWA44EzgM2yLftvQwAPAGdK+rgNOS23DggAEbEzcB+wYY0G/w5cC1wo6be65NYOQERMAy4GapddOP0JsKekBXWAUKuREXG1j2odhpXI+A7YXdLcdnXVAkBEWM7NwIntGpSxfyEwtt0XZF0A+NhfkmF8Xawf+lMqyZ/RStQ2ABGxOfAusGolC9rfNEvS5Kpi6gDgYWCfqgbUtM/vgyeryGoLgIgYDbxWRXHNe+ZKGlNFZrsAPAtMqqJ4APbsKOmFXLmVAYiIYYC/yU2huyUdlWtMOwCcD1yaq3AA+X8Fhkj6I0dHOwD42fc7oEl0kKT7cwyqBECR1joeXyFHWQd4Z0g6K0dPVQCa8vbv7euLknboBAAnALfmKOoQ75/A6pL+TtVX9QRc5LQ0VUmH+YZK+ipVZ1UArgdOTVXSYb6tJL2TqrMqAPcCh6Uq6TDfJEnPp+rMBiAi1gdeArZIVdJhvmmSLkvVmQVAUeB09dbV3KbSImBXSQ7TSykXAB97H/+m0wJJI1KMzAVgFnBsiuAG8LhaVJqp5gLgt2sSsg0A4HRJ15XZkQuA63BDyoQ2ZH26JCds/VIuAM603N4aDDRTkpsytQLwA7B2mdCGrF8h6ZwyW5JPQFH6/hzYqExoQ9bdQXKDpp4TEBHTgXPLBDZo3ad1XFlYnHQCIsJxv+P/wUY+seP7a6qWAhAREwDH1k0rfqT+GJ43GCPJqfJS1C8ARYvbTciNU7U1lO9KSVOrAHAHcExDncoxyzMG27eKDPs8ARGxHfBGjpaG886TZJ+WoP4AeATYu+FO5Zq3ryT71U0tAYiIkcDbudIHAf8cSRNTALimmO0ZBD5lmzii53TJUicgIlYCvgbWzRY9ODYsESK3AmBcUfIaHO7kW7nEy7AVAA53HfYur+RP4jqSPJS59CRXRHgmb//l1fvCr70kPdYXAE8Auy3nAHQ3UVs9Ag8C+7UA4LxB9mi8AvzocboWvnTHA60AcM/Pvb+edI+kIyLi8T4ENvHAHAy8CjiXWauXgU6OFs8YtgKgd+r7aTGKtjAiDgCy+u/LCBmnwcMkLYoID2p7bLcneZDi+74A2ASw005/PZE5UdJ8MxdVIf/vkfcm0xRJniteTBHhSZauAunLksZ3rfUVCrv2vxNwgSSD0U3FIPTTDfb+PWCkpL962X04cCBwuaQ3+wWgzLmI8Bz/oWV8y2jdJ3ZOqu7SilArQRHhAsn7LV4uqXoHim+2JP/SyVQJgOK5Ogm4KVnTwDO6aTNckv8mUyUAImLNYjh6ygDeC0h2omD8qLhV4kg2mbIBiAhHiXcBQ5O1dJbxIWCypG9S1GYBEBGeC3CEtVqK8GXI4zH60ZL8Ge+XkgGICDvtGGB4mdCGrN8mqfQCRw4AJwM3NsS5FDN8yWqDsssUOQDc0uErMSlOlvGM6hn0tGLOAeBO4OgyjQ1bnyDJA119Ug4Afp58Cuokx+hPFXnHDGCbGoW7ObppV+WnL7k5APgKrNEcW4ORfj6nSprZJatow7kW4RykDjpO0u1lgpIBsKCI8HiMs6pTgDXKhLdYd7XZg1ZXSfqy1f4i2Tq7uGds0HPpF9snyW29UsoCoMev5Suxp/kGpzuvxQ3wVsqckc0DPLP3KPCcc/RSq/4Fez3ARY1dAF/F7W8w41vgGcAFG+cDi3P9FPoHZtGfUJ0VObsAAAAASUVORK5CYII="><span>在线客服</span></div></a>
      </el-row>

      <!--    <Footer></Footer>-->

      <Slide></Slide>
    </div>
  </div>
</template>

<script>
  import bidResultApi from '@/api/bidResult'
  import StrKit from '@/utils/str-kit'
  import {isNullOrUndefined, standardFormate} from '../../utils'

  export default {
    name: 'AuctionDetail',
    data () {
      return {
        orderMainId: this.$route.params.orderMainId,
        entity: {},
        detailList: [],
        isShow: true,
        zsDataList:[],
      }
    },
    mounted () {
      this.detail()
      // console.log(this.detailList,'detailList')
      // this.creatQrCode()
    },
    computed:{
      // 是工程服务租赁废旧物资
      isGWZF() {
        const { orderType } = this.entity
        return ['10', '11', '12', '15', '22', '23', '24', '25', '28', '29'].includes(orderType)
      },
      // 是工程服务
      isGW() {
        const { orderType } = this.entity
        return orderType === '10' || orderType === '11' || orderType === '23' || orderType === '22' || orderType === '28' || orderType === '29'
      },
      // 租赁废旧物资
      isZF() {
        const { orderType } = this.entity
        return orderType === '12' || orderType === '15' || orderType === '24' || orderType === '25'
      }
    },
    methods: {
      standardFormate,
      isNullOrUndefined,
      // creatQrCode() {
      //   var qrcode = new QRCode(this.$refs.qrCodeUrl, {
      //     text: 'https://www1.easyjcx.com/#/auction/detail/d72aa939-3157-4471-9792-144147b278aa', // 需要转换为二维码的内容
      //     width: 100,
      //     height: 100,
      //     colorDark: '#000000',
      //     colorLight: '#ffffff',
      //     correctLevel: QRCode.CorrectLevel.H
      //   })
      // },
      isJSON(str) {
        try {
          JSON.parse(str);
        } catch (e) {
          // 转换出错，抛出异常
          return false;
        }
        return JSON.parse(str);
      },
      /* 功能描述：数据加载 */
      detail () {
        if(isNullOrUndefined(this.orderMainId)) {
          this.orderMainId = this.$route.fullPath.split('/').pop()
        }
        bidResultApi.detail(this.orderMainId).then(data => {
          let type = 1
          this.entity = data
          // this.entity.deliverPlace = `江苏省--镇江市--京口区--解放路438号江苏大学附属医院器械科/...`
          // this.entity.doubtDesc = `你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好你好`
          this.detailList = data.detailList
          if(data.orderType == '30'){
            // this.zsDataList =
            data.detailList.forEach(
              detail => {
                detail.bidOrderList.forEach(
                  bidOrder => {
                    bidOrder.type = type
                    this.zsDataList.push(bidOrder)
                    bidOrder.spanCount = detail.bidOrderList.length
                  }
                )
                type++
              }
            )
          }

          console.log(this.zsDataList,'zsDataList')
          console.log(this.entity,'this.entity')
          console.log(this.detailList,'detailList')
        })
      },
      /* 功能描述：获取长度 */
      getByteLen (value) {
        return StrKit.getByteLen(value)
      },
      jsonParse (val) {
        try {
          if (typeof JSON.parse(val) === 'object') {
            this.isShow = false
            return JSON.parse(val)
          }
        } catch (e) {
        }
        this.isShow = true
        return null
      },
      //设置表格第一行的颜色
      getRowClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return 'background-color: #409EFF;color: white;font-weight: 500;'
        }
      },
      headerClass({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return 'background-color: #F6F6F6;color: #000;font-weight: 500;'
        }
      },
      labelName2(orderType) {
        switch (orderType) {
          case '22':
          case '10':
          case '23' :
          case '11' :
          case '28' :
          case '29' :
            return '项目内容'
          case '24' :
          case '12' :
            return '租息内容'
          case '25' :
          case '15' :
            return '废旧物品处置要求'
          case '16' :
          case '26' :
            return '药品要求'
          default : return '规格参数'
        }
      },
      ProName(value) {
        const arr = [
          {
            label: '设备名称',
            value: '1'
          },
          {
            label: '采购项名称',
            value: '2'
          },
          {
            label: '设备名称',
            value: '3'
          },
          {
            label: '采购项名称',
            value: '4'
          },
          {
            label: '采购项名称',
            value: '5'
          },
          {
            label: '采购项名称',
            value: '6'
          },
          {
            label: '采购项名称',
            value: '7'
          },
          {
            label: '试剂名称',
            value: '8'
          },
          {
            label: '耗材名称',
            value: '9'
          },
          {
            label: '项目名称',
            value: '10'
          },
          {
            label: '项目名称',
            value: '11'
          },
          {
            label: '租息名称',
            value: '12'
          },
          {
            label: '采购项名称',
            value: '14'
          },
          {
            label: '处置物资',
            value: '15'
          },
          {
            label: '药品名称',
            value: '16'
          },
          { label: '采购项名称', value: '17' },
          { label: '采购项名称', value: '18' },
          { label: '试剂议价', value: '20' },
          { label: '耗材议价', value: '21' },
          { label: '项目名称', value: '22' },
          { label: '项目名称', value: '23' },
          { label: '租息名称', value: '24' },
          { label: '处置物资', value: '25' },
          { label: '药品名称', value: '26' },
          {
            label: '自定义流程（中国海洋）',
            value: '99'
          },
          {
            label: '设备名称',
            value: '27'
          },
          {
            label: '项目名称',
            value: '28'
          },
          {
            label: '项目名称',
            value: '29'
          },
        ]
        for (const i in arr) {
          if (arr[i].value === value) {
            return arr[i].label
          }
        }
      },
      // objectSpanMethod({ row, column, rowIndex, columnIndex }){
      //   if (columnIndex === 0 && row.spanCount >1){
      //     if(row.isFirst){
      //       console.log(row, column, rowIndex, columnIndex)
      //       row.index = rowIndex
      //       return {
      //         rowspan: row.spanCount,
      //         colspan: 1
      //       }
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0
      //       }
      //     }
      //   } else if(columnIndex === 1 && row.spanCount >1){
      //     if(rowIndex % this.detailList.length == 0){
      //       // console.log(row, column, rowIndex, columnIndex)
      //       console.log(row,'rowspan')
      //       return {
      //         rowspan: row.spanCount,
      //         colspan: 1
      //       }
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0
      //       }
      //     }
      //   }
      // }
      objectSpanMethod({ row, column, rowIndex, columnIndex }){
        // console.log({ row, column, rowIndex, })
        //
        // let spanFields = ['deviceName']
        // let preRow = this.zsDataList[rowIndex-1]
        // let nextRow = this.zsDataList[++rowIndex]
        // if(spanFields.includes(column.property)){
        //   if(preRow[column.property] === row[column.property]){
        //     return {
        //       rowspan: 0,
        //       colspan: 0
        //     }
        //   } else{
        //     while(nextRow[column.property] === row[column.property]){
        //       let count = 1
        //       nextRow = this.zsDataList[++rowIndex]
        //     }
        //     return {
        //       rowspan: count,
        //       colspan: 1
        //     }
        //   }
        // } else return {
        //   rowspan: 1,
        //   colspan: 1
        // }


        // 待合并的字段，数组形式，后续如果其他字段需要合并，直接写进来
        const fields = ['deviceName','type']
        const cellValue = row[column.property]
        // 对于需要合并的字段进行处理，不需要处理的字段默认都是1，1
        if (cellValue && fields.includes(column.property)) {
          const prevRow = this.zsDataList[rowIndex - 1]
          let nextRow = this.zsDataList[rowIndex + 1]
          if (prevRow && prevRow[column.property] === cellValue) {
            // 待合并项都返回0，0
            return {rowspan: 0, colspan: 0}
          } else {
            let countRowspan = 1
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = this.zsDataList[++countRowspan + rowIndex]
            }
            if (countRowspan > 1) {
              row.index = countRowspan
              return {rowspan: countRowspan, colspan: 1}
            }
          }
        }
      }
    }
  }
</script>

<style scoped>
  >>> .custom-form-item .el-form-item__content {
    max-width: 300px; /* 根据实际情况调整 */
  }
  .custom_scrollbar {
    overflow-y: auto !important;
    position: relative;
  }

  /*// 自定义滚动条*/
  .custom_scrollbar::-webkit-scrollbar {
    width: 8px !important;
    height: 1px !important;
  }
  .custom_scrollbar::-webkit-scrollbar-thumb {
    /*小方块*/
    border-radius: 10px !important;
    -webkit-box-shadow: inset 0 0 5px #bbb !important;
    background: #ccc !important;
  }
  .custom_scrollbar:-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    -webkit-box-shadow: inset 0 0 5px #bbb !important;
    border-radius: 10px;
    background: #ccc !important;
  }
  .index {
    width: 100%;
    min-width: 1200px;
    overflow-x: hidden;
  }

  .basic-info {
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  /* 分标题 */
  .auction-details .title-text > span {
    font-size: 18px;
    color: #333333;
    line-height: 30px;
    padding: 16px 5px;
  }
  /*分标题下划线*/
  .small-line {
    width: 120px;
    height: 4px;
    background: #1a88e0;
    margin-top: 8px;
  }
  .title-line {
    width: 100%;
    height: 1px;
    background: #e5e5e5;
  }

  /*文本域*/
  textarea {
    border: none;
    height: 100%;
    font-size: 12px;
    resize: none;
    color: #666666;
    padding-top: 10px;
    outline: none;
  }

  /*在线客服*/
  .service-box {
    width: 40px;
    height: 125px;
    background: #de6c07;
    text-align: center;
    margin-top: 152px;
  }
  .service-box span {
    margin-top: 5px;
    letter-spacing: 5px;
    font-size: 15px;
    color: #fff;
    writing-mode: vertical-lr;
    writing-mode: tb-lr;
  }
  .qq {
    width: 30px;
    height: 30px;
  }
</style>
<style>
  /* 表单 */
  .auction-details .el-col {
    margin-top: 0px !important;
  }
  .auction-details .el-form-item {
    margin-bottom: 0px;
    width: 100%;
  }
  .auction-details .el-form-item__content {
    font-size: 12px;
    color: #666666;
    display: inline-block;
    vertical-align: top;
  }
  .auction-details .el-form-item__label {
    font-weight: bold;
  }

  /* 文本域textarea */
  .textareaBc .el-textarea__inner{
    margin-top: 12px;
    background-color: #ededed;
  }

  textareaBc2 .el-textarea__inner{
    margin-top: 12px;
  }
  .auction-details .el-textarea__inner{
    font-family: "Helvetica Neue";
    width: 600%;
    border: none;
    resize: none;
    padding:0px;
    margin-bottom: 10px;
    font-size: 12px;
    overflow-y: hidden;
  }

  /* checkbox图标 */
  .explain .el-checkbox__input.is-disabled .el-checkbox__inner {
    background-color: #fff;
    cursor: auto;
  }
  /* 文本域textarea */
  .puInp .el-textarea__inner{
    font-family: "Helvetica Neue";
    width: 100%;
    border: none;
    resize: none;
    padding: 10px 0;
    font-size: 12px;
    overflow-y: hidden;
  }
  .ColRed textarea.el-textarea__inner{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/views/auction/detail.vue